import { useState } from "react";

export default function ContactList({ contacts, deleteContact, updateContact, logout }) {
  const [editingContact, setEditingContact] = useState(null);
  const [updatedName, setUpdatedName] = useState("");
  const [updatedEmail, setUpdatedEmail] = useState("");
  const [updatedPhone, setUpdatedPhone] = useState("");

  const startEdit = (contact) => {
    setEditingContact(contact.id);
    setUpdatedName(contact.name);
    setUpdatedEmail(contact.email);
    setUpdatedPhone(contact.phone);
  };

  const handleUpdate = () => {
    if (!updatedName || !updatedEmail || !updatedPhone) return;
    
    updateContact(editingContact, {
      name: updatedName,
      email: updatedEmail,
      phone: updatedPhone
    });

    setEditingContact(null);
  };

  return (
    <div>
      <h2>Contacts</h2>
      <button onClick={logout}>Logout</button>
      <ul>
        {contacts.length > 0 ? (
          contacts.map((contact) => (
            <li key={contact.id}>
              {editingContact === contact.id ? (
                <div>
                  <input
                    type="text"
                    value={updatedName}
                    onChange={(e) => setUpdatedName(e.target.value)}
                  />
                  <input
                    type="email"
                    value={updatedEmail}
                    onChange={(e) => setUpdatedEmail(e.target.value)}
                  />
                  <input
                    type="text"
                    value={updatedPhone}
                    onChange={(e) => setUpdatedPhone(e.target.value)}
                  />
                  <button onClick={handleUpdate}>✅ Save</button>
                  <button onClick={() => setEditingContact(null)}>❌ Cancel</button>
                </div>
              ) : (
                <>
                  {contact.name} - {contact.email} - {contact.phone}
                  <button onClick={() => startEdit(contact)}>✏ Edit</button>
                  <button onClick={() => deleteContact(contact.id)}>🗑 Delete</button>
                </>
              )}
            </li>
          ))
        ) : (
          <p>No contacts found. Try adding one!</p>
        )}
      </ul>
    </div>
  );
}
